import { makeStyles } from 'e100-react-components';

interface StylesProps {
  color: string;
}

export const useStyles = makeStyles(({ spacing, palette }) => ({
  container: {
    display: 'table-cell',
    width: spacing(1.25),
    backgroundColor: 'transparent',
    lineHeight: 0,
    fontSize: 0,
    textAlign: 'center',
    verticalAlign: 'middle',
  },
  icon: {
    display: 'inline-block',
    width: spacing(1.25),
    height: spacing(1.25),
    borderRadius: '50%',
    border: ({ color }: StylesProps) => `2px solid ${color}`,
    backgroundColor: ({ color }: StylesProps) => `${color}`,
  },
}));
